import moment from "moment";
import { MBase } from "./MBase";

export class GrupoEquipamento  extends MBase{
    Id: number;
    Descricao:string = "";
    SistemaId: number;
    Ativo:boolean = true;
    EmpresaId: number;
    UsuarioAlteracaoDesc: string;

    DataAlteracaoFilter: Date;
    AtivoDesc: string = "";

    get dataAlteracaoStr(): string{
        return moment(this.DataAlteracao).format('DD/MM/YYYY HH:mm')
    }
}
